import './style.sass';
import React from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const UkassaTarget = () => {
    const sliderImg = [
        '/images/svg/ukassa/slider/1.svg',
        '/images/svg/ukassa/slider/2.svg',
        '/images/svg/ukassa/slider/3.svg',
        '/images/svg/ukassa/slider/4.svg',
        '/images/svg/ukassa/slider/5.svg',
        '/images/svg/ukassa/slider/6.svg',
    ];

    SwiperCore.use([Autoplay]);

    return (
        <div className="ukassa-target">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <FullWrapper>
                    <div className="ukassa-target__block">
                        <div className="ukassa-target__wrap">
                            <span className="ukassa-target__title">Цель</span>
                            <span className="ukassa-target__text">
                                Как можно быстрее восстановить объем небрендового трафика (70+
                                кластеризаций) после переезда домена.
                            </span>
                        </div>
                        <div className="ukassa-target__wrap ukassa-target__wrap-img">
                            <Swiper
                                isDuplicate={true}
                                direction={'vertical'}
                                spaceBetween={0}
                                slidesPerView={5}
                                autoHeight={true}
                                loop={true}
                                longSwipes={true}
                                longSwipesMs={800}
                                longSwipesRatio={0.8}
                                speed={800}
                                autoplay={{ delay: 1500 }}
                            >
                                {sliderImg.map(img => (
                                    <SwiperSlide key={img}>
                                        <div className="ukassa-target__wrap-item">
                                            <img
                                                src={img}
                                                alt=""
                                                className="ukassa-target__img"
                                                loading="lazy"
                                            />
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        </div>
    );
};

export default UkassaTarget;
